export { WithGradientedName, getWithGradientedName } from './WithGradientedName';
